import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div>
      <div
        style={{
          backgroundImage:
            'url("https://www.tirumala.org/NewImages/Head-Bg.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "120px",
        }}
      >
        {/* Left: Logo */}
        <img
          src="https://www.tirumala.org/NewImages/TTD-Logo.png"
          alt="TTD Logo"
          style={{ height: "100px", objectFit: "contain" }}
        />

        {/* Center: Text */}
        <img
          src="https://www.tirumala.org/NewImages/HD-TXT.png"
          alt="TTD Text"
          style={{ height: "80px", objectFit: "contain" }}
        />

        {/* Right: Head Image */}
        <img
          src="https://www.tirumala.org/NewImages/TTD-Head-Img.png"
          alt="TTD Head"
          style={{ height: "100px", objectFit: "contain" }}
        />
      </div>
    </div>
  );
};

export default Header;
